import { motion } from 'framer-motion'

const socials = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/idm_medicina',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@idm.medicina',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@AprobamedicinaconDante',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23 7s-.3-1.9-1.2-2.7c-1.1-1.2-2.4-1.2-3-1.3C16.6 3 12 3 12 3s-4.6 0-6.8.2c-.6.1-1.9.1-3 1.3C1.3 5.3 1 7 1 7S.7 9.1.7 11.2v2c0 2 .3 4.2.3 4.2s.3 1.9 1.2 2.7c1.1 1.2 2.6 1.1 3.3 1.2C7.6 21.4 12 21.4 12 21.4s4.6 0 6.8-.3c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.7 1.2-2.7s.3-2.1.3-4.2v-2C23.3 9.1 23 7 23 7zM9.7 15.5V8.4l8.1 3.6-8.1 3.5z"/>
      </svg>
    ),
  },
  {
    label: 'Hotmart',
    href: 'https://hotmart.com/TU_PERFIL',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14.5v-9l7 4.5-7 4.5z"/>
      </svg>
    ),
  },
]

export default function Footer() {
  return (
    <footer
      className="relative"
      style={{ borderTop: '1px solid var(--line)', background: 'var(--bg)' }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-8 px-[5vw] py-14">

        {/* Logo / nombre */}
        <div className="flex flex-col items-center md:items-start gap-1">
          <span
            className="font-display font-black text-[15px] tracking-[0.14em] uppercase"
            style={{ color: 'var(--gold)' }}
          >
            Medicina con Dante
          </span>
          <span
            className="font-body font-light text-[11px] tracking-[0.08em]"
            style={{ color: 'var(--ink-3)' }}
          >
            Aprender medicina de otra manera
          </span>
        </div>

        {/* Íconos de redes */}
        <div className="flex items-center gap-5">
          {socials.map(s => (
            <motion.a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="flex flex-col items-center gap-1.5 group"
              style={{ color: 'var(--ink-3)' }}
              whileHover={{ color: 'var(--gold)', y: -2 }}
              transition={{ duration: 0.2 }}
            >
              {s.icon}
              <span
                className="font-body text-[10px] tracking-[0.06em]"
                style={{ color: 'inherit' }}
              >
                {s.label}
              </span>
            </motion.a>
          ))}
        </div>

        {/* Copyright */}
        <span
          className="font-body text-[12px]"
          style={{ color: 'var(--ink-3)' }}
        >
          © 2025 · Todos los derechos reservados
        </span>
      </div>

      {/* Bottom gold line accent */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px] pointer-events-none"
        style={{
          background: 'linear-gradient(90deg, transparent, var(--gold) 30%, var(--gold) 70%, transparent)',
          opacity: 0.15,
        }}
      />
    </footer>
  )
}